import { ErrorEvent, ExceptionEvent, TimeoutEvent } from 'react-native-sse';

import AsyncStorage from '@react-native-async-storage/async-storage';

import { RaceToPlaceEntry } from '@/types/socialFeed.generated';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export type RaceToPlaceStore = {
    raceToPlaceData: RaceToPlaceEntry | null;
    loading: boolean;
    isR2PCarouselInViewPort: boolean;
    error?: ErrorEvent | TimeoutEvent | ExceptionEvent;
    actions: {
        setData: (value: RaceToPlaceEntry) => void;
        setLoading: (value: boolean) => void;
        setError: (value?: ErrorEvent | TimeoutEvent | ExceptionEvent) => void;
        setIsR2PCarouselInViewPort: (value: boolean) => void;
    };
};

export const useRaceToPlaceStore = create<RaceToPlaceStore>()(
    persist(
        set => ({
            raceToPlaceData: null,
            isR2PCarouselInViewPort: false,
            loading: false,
            error: undefined,
            actions: {
                setData: value => {
                    set({ raceToPlaceData: value });
                },
                setLoading: value => {
                    set({ loading: value });
                },
                setError: value => {
                    set({ error: value });
                },
                setIsR2PCarouselInViewPort: value => {
                    set({ isR2PCarouselInViewPort: value });
                },
            },
        }),
        {
            name: 'race-to-place-storage',
            version: 3,
            storage: createJSONStorage(() => AsyncStorage),
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            partialize: ({ actions, ...rest }: RaceToPlaceStore) => rest,
        }
    )
);
